import { render, staticRenderFns } from "./Fonts.vue?vue&type=template&id=47a0996e&scoped=true"
import script from "./Fonts.vue?vue&type=script&setup=true&lang=js"
export * from "./Fonts.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Fonts.vue?vue&type=style&index=0&id=47a0996e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a0996e",
  null
  
)

export default component.exports